const VcomSection = {
  ANALYSIS: 'analysis',
  CALENDAR: 'calendar',
  COCKPIT: 'cockpit',
  CONTROL_ROOM: 'controlRoom',
  DASHBOARD: 'dashboard',
  DOCUMENTS: 'documents',
  EVALUATION: 'evaluation',
  MONITORING: 'monitoring',
  VIIU: 'viiu',
  PPC: 'ppc',
};
export default VcomSection;
